"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const map_1 = __importDefault(require("lodash-es/map"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const SharedPropsService_1 = __importDefault(require("../SharedPropsService"));
const types_1 = require("@voltmoney/types");
const utility_1 = require("../utility");
const RenderItem_1 = __importDefault(require("./RenderItem"));
const standardUtility_1 = require("../utility/standardUtility");
const context_1 = require("../context");
const BottomSheet_1 = __importDefault(require("../components/BottomSheet"));
const lodash_es_1 = require("lodash-es");
const react_native_modal_1 = __importDefault(require("react-native-modal"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const styles = react_native_1.StyleSheet.create({
    [types_1.POSITION.CENTER]: {
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
    [types_1.POSITION.ABSOLUTE_CENTER]: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
    },
    [types_1.POSITION.FIXED_TOP]: {
        marginHorizontal: 16,
    },
    [types_1.POSITION.ABSOLUTE_TOP]: { marginHorizontal: 0 },
    [types_1.POSITION.BODY]: {
        marginHorizontal: 16,
    },
    [types_1.POSITION.FIXED_BOTTOM]: {
        marginHorizontal: 16,
    },
    [types_1.POSITION.ABSOLUTE_BOTTOM]: {
        marginHorizontal: 16,
        marginBottom: 16,
    },
    [types_1.POSITION.STICKY_BOTTOM]: {
        marginHorizontal: 0,
        marginBottom: 0,
    },
    [types_1.POSITION.FAB]: {
        position: 'absolute',
        bottom: 32,
        left: 0,
        right: 0,
    },
    [types_1.POSITION.NAVBAR_LEFT]: {
        width: 230,
        elevation: 2,
        shadowColor: '#000',
        shadowOffset: {
            width: 1,
            height: 0,
        },
        shadowOpacity: 0.1,
        shadowRadius: 6,
    },
    [types_1.POSITION.NAVBAR_RIGHT]: {
        width: 200,
    },
});
const PageRender = ({ template, onEndReached, onRefresh = () => {
}, routeId, isLoading = false, hasNotch, heightScreen = 0, widthScreen = 0, pageRefreshCount = 0, }) => {
    const [keyboardHeight, setKeyboardHeight] = (0, react_1.useState)(0);
    const [modalHeight, setModalHeight] = (0, react_1.useState)(0);
    const viewRef = react_1.default.useRef(null);
    const modalRef = (0, react_1.useRef)(null);
    const isPartnerPlatform = (0, lodash_es_1.get)(template, 'layout.style.isPartnerPlatform', false);
    const partnerPlatform = (0, utility_1.getCurrentURL)()
        .toLowerCase()
        .includes('partnerplatform');
    const platform = (0, utility_1.getCurrentURL)()
        .toLowerCase()
        .includes('platform');
    const params = (0, utility_1.getParameters)((0, utility_1.getCurrentURL)());
    const platformName = (params === null || params === void 0 ? void 0 : params.platform) || '';
    let isDarkMode = null || "";
    if (react_native_1.Platform.OS === 'web') {
        isDarkMode = params === null || params === void 0 ? void 0 : params.isDarkMode;
    }
    if (routeId !== 'CONTACT_US_CARD' &&
        routeId !== 'CONTACT_US') {
        async_storage_1.default.setItem('routeId', routeId);
    }
    let phonePayRoutes = [standardUtility_1.ROUTE.EMAIL_VERIFY, standardUtility_1.ROUTE.PAN_CONFIRM_NAME, standardUtility_1.ROUTE.MF_FETCH_PORTFOLIO, standardUtility_1.ROUTE.MF_PLEDGE_PORTFOLIO, standardUtility_1.ROUTE.SET_CREDIT_LIMIT, standardUtility_1.ROUTE.CHECKING_LIMIT, standardUtility_1.ROUTE.KYC_PAN_VERIFICATION, standardUtility_1.ROUTE.UNLOCK_LIMIT_LANDING, standardUtility_1.ROUTE.PLEDGE_CONFIRMATION, standardUtility_1.ROUTE.PORTFOLIO, standardUtility_1.ROUTE.KFS_SCREEN, standardUtility_1.ROUTE.OTP_AUTH_CAS, standardUtility_1.ROUTE.UPDATE_SLIDER_AMOUNT, standardUtility_1.ROUTE.MODIFY_PLEDGED_AMOUNT, standardUtility_1.ROUTE.PORTFOLIO_FROM_RTA, standardUtility_1.ROUTE.JOINT_HOLDER_NOTIFY, standardUtility_1.ROUTE.UPDATE_PHONE_NUMBER, standardUtility_1.ROUTE.UPDATE_EMAIL_ID];
    (0, react_1.useEffect)(() => {
        const showSubscription = react_native_1.Keyboard.addListener('keyboardDidShow', (e) => {
            var _a;
            if (OnScrollRef && template.layout.type !== types_1.LAYOUTS.MODAL && routeId !== "BANK_SELECT" && routeId !== "DIGIO_MODAL") {
                console.log("IN THE KEYBOARD BLOCK");
                // @ts-ignore
                (_a = OnScrollRef === null || OnScrollRef === void 0 ? void 0 : OnScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToEnd();
            }
            setKeyboardHeight(e.endCoordinates.height);
        });
        const hideSubscription = react_native_1.Keyboard.addListener('keyboardDidHide', () => setKeyboardHeight(0));
        return () => {
            showSubscription.remove();
            hideSubscription.remove();
        };
    }, [setKeyboardHeight]);
    const widgetIdByRouteId = (0, react_1.useRef)({});
    const refreshTemplate = JSON.stringify(template);
    const { state, setActions, setDataStoreInPath, appendWidgets, removeWidgets, } = (0, react_1.useContext)(context_1.Context);
    const OnScrollRef = react_1.default.useRef(null);
    const callOnScrollEnd = (0, react_1.useRef)(false);
    const standardUtilities = (0, react_1.useMemo)(() => (0, standardUtility_1.standardUtilitiesRaw)(state, setDataStoreInPath, appendWidgets, removeWidgets, template.layout.id, heightScreen, widthScreen), [state, refreshTemplate]);
    const isMobile = (screenType) => screenType === types_1.SCREEN_SIZE.X_SMALL ||
        screenType === types_1.SCREEN_SIZE.SMALL;
    const getScreenType = (screenWidth) => {
        const screenWidthX = screenWidth || react_native_1.Dimensions.get('window').width;
        if (screenWidthX < 576)
            return types_1.SCREEN_SIZE.X_SMALL;
        if (screenWidthX < 768)
            return types_1.SCREEN_SIZE.SMALL;
        if (screenWidthX < 992)
            return types_1.SCREEN_SIZE.MEDIUM;
        if (screenWidthX < 1200)
            return types_1.SCREEN_SIZE.LARGE;
        if (screenWidthX >= 1200)
            return types_1.SCREEN_SIZE.X_LARGE;
        return types_1.SCREEN_SIZE.X_SMALL;
    };
    const shouldScrollVerticalByRouteId = (_routeId) => {
        if (_routeId === 'KYC_PHOTO_VERIFICATION' || isMobile(getScreenType()) && _routeId === "COLLATERAL" || isMobile(getScreenType()) && _routeId === "DEMO_VIDEOS") {
            return false;
        }
        return true;
    };
    const triggerAction = (0, react_1.useCallback)((action) => __awaiter(void 0, void 0, void 0, function* () {
        if (!action.routeId)
            action.routeId = routeId;
        switch (action.type) {
            /**
             * Global Action Handle - Update Datastore for routeId -> widgetId
             * */
            case types_1.GlobalActionTokens.SET_DATASTORE_IN_PATH: {
                if (setDataStoreInPath) {
                    yield setDataStoreInPath(action);
                }
                break;
            }
            /**
             * Global Action Handle - Set Action map for routeId
             * */
            case types_1.GlobalActionTokens.SET_ACTIONS: {
                if (setActions) {
                    yield setActions(action);
                }
                break;
            }
            default: {
                /**
                 * Custom Action Handle
                 * */
                const template = action.routeId &&
                    state.routeMap &&
                    state.routeMap[action.routeId].template;
                const actionsMap = template &&
                    action.routeId &&
                    state.routeMap &&
                    state.routeMap[action.routeId].actions;
                if (actionsMap != null &&
                    template.datastore != null) {
                    yield actionsMap[action.type](action, template === null || template === void 0 ? void 0 : template.datastore, standardUtilities);
                }
                break;
            }
        }
    }), []);
    const getPercentage = (route) => {
        console.log("route is", route);
        switch (route) {
            case "SELECT_SOURCE": {
                return '34%';
            }
            case "KYC_PAN_VERIFICATION": {
                return '23%';
            }
            case "PAN_CONFIRM_NAME": {
                return '32%';
            }
            case "ALERT_PAGE": {
                return '41%';
            }
            case "MF_FETCH_PORTFOLIO": {
                return '80%';
            }
            case "OTP_AUTH_CAS": {
                return '40%';
            }
            case "UPDATE_SLIDER_AMOUNT": {
                return '26%';
            }
            case "PLEDGE_VERIFY": {
                return '40%';
            }
            default: {
                return '35%';
            }
        }
    };
    (0, react_1.useLayoutEffect)(() => {
        const action = state.routeMap[routeId].action;
        const actionDelay = state.routeMap[routeId].actionDelay || 0;
        if (action && !actionDelay) {
            triggerAction(action).catch((error) => console.warn('auto action trigger failed', action, error));
        }
        else if (action && actionDelay) {
            setTimeout(() => {
                triggerAction(action).catch((error) => console.warn('auto action trigger failed with delay', action, actionDelay, error));
            }, actionDelay);
        }
        /*** handle back key press on Android ***/
        const backHandler = react_native_1.BackHandler.addEventListener('hardwareBackPress', () => template.layout.isDismissible);
        return () => backHandler.remove();
    }, [pageRefreshCount]);
    const EnableOnEndReach = () => (callOnScrollEnd.current = true);
    const onScroll = (0, react_1.useCallback)(() => {
        if (callOnScrollEnd.current) {
            if (!onEndReached)
                return;
            onEndReached(standardUtilities);
            callOnScrollEnd.current = false;
        }
    }, [callOnScrollEnd.current]);
    const setRef = (0, react_1.useCallback)((ref) => __awaiter(void 0, void 0, void 0, function* () {
        OnScrollRef.current = ref;
        yield SharedPropsService_1.default.setWidgetRefMap(template.layout.id, OnScrollRef.current);
    }), []);
    const _renderItem = (0, react_1.useCallback)((item) => {
        return (react_1.default.createElement(react_native_1.View, { key: `${routeId}-${item.id}`, style: Object.assign(Object.assign({}, (0, utility_1.applyMargin)(item.padding)), (0, utility_1.applyStyle)(item.position)) },
            react_1.default.createElement(RenderItem_1.default, { key: item.id, item: item, routeId: routeId, 
                // isLoading={isLoading}
                triggerAction: triggerAction, heightScreen: heightScreen, widthScreen: widthScreen })));
    }, [
        routeId,
        triggerAction,
        heightScreen,
        widthScreen,
    ]);
    const _renderListItem = (0, react_1.useCallback)(({ item }) => {
        return (react_1.default.createElement(react_native_1.View, { style: (isPartnerPlatform || routeId === standardUtility_1.ROUTE.INTEREST_REPAYMENT_DETAILS) ? {} : styles[types_1.POSITION.BODY] }, _renderItem(item)));
    }, [_renderItem]);
    /********* UI render Logic goes from here **********/
    const ui = {
        idRegister: {},
        [types_1.POSITION.FIXED_TOP]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.FIXED_BOTTOM]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.STICKY_BOTTOM]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.ABSOLUTE_TOP]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.ABSOLUTE_BOTTOM]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.ABSOLUTE_CENTER]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.CENTER]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.FAB]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.BODY]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.NAVBAR_LEFT]: {
            render: undefined,
            widgetItems: [],
        },
        [types_1.POSITION.NAVBAR_RIGHT]: {
            render: undefined,
            widgetItems: [],
        },
    };
    const _layoutMapper = (0, react_1.useCallback)(() => {
        template.layout.widgets.map((widgetItem) => {
            const x = widgetIdByRouteId.current[routeId];
            if (routeId && widgetItem.type)
                widgetIdByRouteId.current[routeId] = `${x ? `${x},` : ''} ${widgetItem.type}`;
            const nestedList = (0, lodash_es_1.get)(template, `datastore.${widgetItem.id}.widgetItems`, []);
            if (nestedList.length > 0) {
                const y = widgetIdByRouteId.current[routeId];
                nestedList.map((item) => {
                    widgetIdByRouteId.current[routeId] = `${y},${item.type}`;
                });
            }
            const widgetId = `${routeId}.${widgetItem.id}`;
            /*** skip render if already widgetId registered */
            if (!ui.idRegister[widgetId]) {
                /*** defaulting to body if no position is provided */
                widgetItem.position =
                    widgetItem.position || types_1.POSITION.BODY;
                /*** splitting widgets based on position */
                ui[widgetItem.position].widgetItems.push(widgetItem);
                /*** registering widget id for future use */
                ui.idRegister[widgetId] = widgetItem;
            }
        });
    }, [refreshTemplate]);
    /*** uncomment to print widgets present in each route */
    // useEffect(() => {
    // 	console.info(
    // 		`*** ${routeId} -> ${widgetIdByRouteId.current[routeId]}`,
    // 		...new Set(
    // 			widgetIdByRouteId.current[routeId].split(','),
    // 		),
    // 	);
    // }, []);
    /*** mapping layout to ui */
    _layoutMapper();
    (0, react_1.useEffect)(() => {
        if (routeId === 'PARTNER_REFERRED_PARTNER') {
            //@ts-ignore
            OnScrollRef.current.scrollToOffset({ animated: false, offset: 0 });
        }
    }, []);
    /*** build UI for each position type ***/
    ui[types_1.POSITION.CENTER].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.CENTER]] }, (0, map_1.default)(ui[types_1.POSITION.CENTER].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.ABSOLUTE_CENTER].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.ABSOLUTE_CENTER]] }, (0, map_1.default)(ui[types_1.POSITION.ABSOLUTE_CENTER].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.STICKY_BOTTOM].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.STICKY_BOTTOM]] }, (0, map_1.default)(ui[types_1.POSITION.STICKY_BOTTOM].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.ABSOLUTE_BOTTOM].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: isPartnerPlatform ? {} : [styles[types_1.POSITION.ABSOLUTE_BOTTOM]] }, (0, map_1.default)(ui[types_1.POSITION.ABSOLUTE_BOTTOM].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.ABSOLUTE_TOP].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.ABSOLUTE_TOP]] }, (0, map_1.default)(ui[types_1.POSITION.ABSOLUTE_TOP].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.FIXED_TOP].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.FIXED_TOP]] }, (0, map_1.default)(ui[types_1.POSITION.FIXED_TOP].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.FIXED_BOTTOM].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.FIXED_BOTTOM]] }, (0, map_1.default)(ui[types_1.POSITION.FIXED_BOTTOM].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.FAB].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.FAB]] }, (0, map_1.default)(ui[types_1.POSITION.FAB].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.NAVBAR_LEFT].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.NAVBAR_LEFT]] }, (0, map_1.default)(ui[types_1.POSITION.NAVBAR_LEFT].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.NAVBAR_RIGHT].render = (0, react_1.useMemo)(() => (react_1.default.createElement(react_native_1.View, { style: [styles[types_1.POSITION.NAVBAR_RIGHT]] }, (0, map_1.default)(ui[types_1.POSITION.NAVBAR_RIGHT].widgetItems, _renderItem))), [refreshTemplate]);
    ui[types_1.POSITION.BODY].render = react_1.default.useMemo(() => (react_1.default.createElement(react_native_1.FlatList, { ref: setRef, bounces: false, maxToRenderPerBatch: 5, windowSize: 5, nestedScrollEnabled: true, renderItem: _renderListItem, data: ui[types_1.POSITION.BODY].widgetItems, extraData: ui[types_1.POSITION.BODY].widgetItems, onEndReachedThreshold: 0.5, showsVerticalScrollIndicator: platformName.includes('REDVISION') ? false : true, showsHorizontalScrollIndicator: false, keyboardDismissMode: 'none', keyboardShouldPersistTaps: "always", onEndReached: EnableOnEndReach, onMomentumScrollEnd: onScroll, 
        // refreshControl={
        // 	<RefreshControl
        // 		refreshing={isLoading}
        // 		onRefresh={onRefresh}
        // 	/>
        // }
        ListHeaderComponent: react_1.default.createElement(react_1.default.Fragment, null,
            ui[types_1.POSITION.FIXED_TOP].render,
            react_1.default.createElement(react_native_1.View, { style: {
                    height: isPartnerPlatform
                        || (routeId === "BANK_ACCOUNT_VERIFICATION"
                            || routeId === "BANK_ACCOUNT_ADD"
                            || routeId === "KYC_ADDITIONAL_DETAILS"
                            || routeId === "CO_BORROWER_ADDITIONAL_DETAILS"
                            || routeId === "NAME_MISMATCH"
                            || routeId === "KYC_DOCUMENTS_DIGIO_BASE"
                            || routeId === "CO_BORROWER_KYC_DIGIO_BASE"
                            || routeId === "MANAGE_LIMIT"
                            || routeId === "VIEW_PORTFOLIO_DETAIL"
                            || routeId === "UNPLEDGE_FUNDS"
                            || routeId === "FORECLOSURE"
                            || routeId === "OUTSTANDING_DUES"
                            || routeId === "UNPLEDGE_STATUS"
                            || routeId === "DIGIO_MANDATE_SIGN"
                            || routeId === "KFS_SCREEN"
                            || routeId === "ASSET_PLEDGE_V2"
                            || routeId === "KYC_STEPPER"
                            || routeId === "MANAGE_LIMIT_LANDING"
                            || routeId === "VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT"
                            || routeId === "PRE_DASHBOARD_SCREEN") ? 0 : 16
                } })), ListFooterComponent: react_1.default.createElement(react_1.default.Fragment, null, ui[types_1.POSITION.FIXED_BOTTOM].render) })), [refreshTemplate]);
    //@todo - remove this from platform
    /** [Toggle Navigation Linking Added to send notification to Android/iOS WebView Navigation Changes] **/
    /** remove Splash Screen Primary Color**/
    const _child = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: {
                paddingHorizontal: 0,
            } }, ui[types_1.POSITION.ABSOLUTE_TOP].widgetItems
            .length > 0 &&
            ui[types_1.POSITION.ABSOLUTE_TOP].render),
        react_1.default.createElement(react_native_1.ScrollView, { scrollEnabled: shouldScrollVerticalByRouteId(routeId), showsVerticalScrollIndicator: platformName.includes('REDVISION') ? false : true, showsHorizontalScrollIndicator: platformName.includes('REDVISION') ? false : true, nestedScrollEnabled: true, contentContainerStyle: { flexGrow: 1 }, keyboardShouldPersistTaps: 'handled', style: {
                flex: 1,
                backgroundColor: platform &&
                    partnerPlatform &&
                    // platformName.includes('SDK_INVESTWELL') &&
                    routeId === 'SPLASH_SCREEN'
                    ? 'white'
                    : (isDarkMode && phonePayRoutes.includes(routeId)) ? '#0D141F' : state.routeMap[routeId].bgColor ||
                        'white',
            } },
            react_1.default.createElement(react_native_1.View, { style: { flex: 1, flexDirection: 'column' } },
                react_1.default.createElement(react_native_1.View, { style: { flex: 1, flexDirection: 'row' } },
                    ui[types_1.POSITION.NAVBAR_LEFT].widgetItems
                        .length > 0 &&
                        ui[types_1.POSITION.NAVBAR_LEFT].render,
                    react_1.default.createElement(react_native_1.View, { style: {
                            flex: 1,
                            flexDirection: 'column',
                        } }, ui[types_1.POSITION.BODY].widgetItems.length >
                        0 && ui[types_1.POSITION.BODY].render),
                    ui[types_1.POSITION.NAVBAR_RIGHT].widgetItems
                        .length > 0 &&
                        ui[types_1.POSITION.NAVBAR_RIGHT].render),
                ui[types_1.POSITION.CENTER].widgetItems.length >
                    0 && ui[types_1.POSITION.CENTER].render,
                ui[types_1.POSITION.ABSOLUTE_CENTER].widgetItems
                    .length > 0 &&
                    ui[types_1.POSITION.ABSOLUTE_CENTER].render)),
        react_1.default.createElement(react_native_1.View, null,
            ui[types_1.POSITION.FAB].widgetItems.length > 0 &&
                ui[types_1.POSITION.FAB].render,
            ui[types_1.POSITION.ABSOLUTE_BOTTOM].widgetItems
                .length > 0 &&
                ui[types_1.POSITION.ABSOLUTE_BOTTOM].render,
            ui[types_1.POSITION.STICKY_BOTTOM].widgetItems
                .length > 0 &&
                ui[types_1.POSITION.STICKY_BOTTOM].render))), [
        refreshTemplate,
        ui[types_1.POSITION.ABSOLUTE_TOP].render,
        ui[types_1.POSITION.CENTER].render,
        ui[types_1.POSITION.BODY].render,
        ui[types_1.POSITION.ABSOLUTE_CENTER].render,
        ui[types_1.POSITION.FAB].render,
        ui[types_1.POSITION.ABSOLUTE_BOTTOM].render,
        ui[types_1.POSITION.STICKY_BOTTOM].render,
    ]);
    const find_dimesions = (event) => {
        const { x, y, width, height } = event.nativeEvent.layout;
        setModalHeight(height);
        console.warn(x);
        console.warn(y);
        console.warn(width);
        console.warn("Modal height is", height);
    };
    const renderForceUpdateModal = () => {
        var _a;
        if (OnScrollRef.current) {
            // @ts-ignore
            (_a = OnScrollRef === null || OnScrollRef === void 0 ? void 0 : OnScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToEnd();
        }
        console.log('height received is', (0, lodash_es_1.get)(template, 'layout.style.height', 256));
        const alignment = (0, lodash_es_1.get)(template, 'layout.style.alignment', types_1.ModalAlignmentEnum.BOTTOM);
        // @ts-ignore
        console.log("alignment 123:  ", alignment);
        switch (alignment) {
            case types_1.ModalAlignmentEnum.LEFT:
                return (react_1.default.createElement(react_native_modal_1.default, { isVisible: true, style: {
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    } },
                    react_1.default.createElement(react_native_1.View, { style: {
                            backgroundColor: 'white',
                            padding: 16,
                            alignItems: 'center',
                        } }, _child)));
                break;
            case types_1.ModalAlignmentEnum.RIGHT:
                return (react_1.default.createElement(react_native_modal_1.default, { isVisible: true },
                    react_1.default.createElement(react_native_1.View, { style: {
                            flex: 1,
                            justifyContent: 'center',
                            alignItems: 'flex-end',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        } },
                        react_1.default.createElement(react_native_1.View, { style: {
                                padding: 16,
                                alignItems: 'center',
                            } }, _child))));
                break;
            case types_1.ModalAlignmentEnum.CENTER:
                return (react_1.default.createElement(react_native_modal_1.default, { isVisible: true },
                    react_1.default.createElement(react_native_1.View, { style: {
                            justifyContent: 'center',
                            alignItems: 'center',
                        } }, _child)));
                break;
            default:
                return (react_1.default.createElement(react_native_modal_1.default, { isVisible: true, style: { justifyContent: 'flex-end', flex: 1 }, statusBarTranslucent: true, avoidKeyboard: react_native_1.Platform.OS === "ios" && routeId !== 'DIGIO_MODAL' && routeId !== "DIGIO_MODAL_CO_BORROWER" && routeId !== "DIGIO_DOC_MODAL" ? true : false },
                    react_1.default.createElement(react_native_1.View, { style: {
                            height: (0, lodash_es_1.get)(template, 'layout.style.height', 256), margin: -22
                        } }, _child),
                    keyboardHeight > 0 && react_native_1.Platform.OS === 'android' && routeId !== "DIGIO_MODAL" && routeId !== "DIGIO_MODAL_CO_BORROWER" && routeId !== "DIGIO_DOC_MODAL" && (react_1.default.createElement(react_native_1.View, { style: { height: keyboardHeight + 22 } }))));
                break;
        }
        // @ts-ignore
        return (react_1.default.createElement(react_native_modal_1.default, { isVisible: true, style: { justifyContent: 'flex-end', flex: 1 }, statusBarTranslucent: true, avoidKeyboard: react_native_1.Platform.OS === "ios" && routeId !== 'DIGIO_MODAL' && routeId !== "DIGIO_MODAL_CO_BORROWER" ? true : false },
            react_1.default.createElement(react_native_1.View, { style: {
                    height: (0, lodash_es_1.get)(template, 'layout.style.height', 256), margin: -22
                } }, _child),
            keyboardHeight > 0 && react_native_1.Platform.OS === 'android' && routeId === "DIGIO_MODAL" && routeId !== "DIGIO_MODAL_CO_BORROWER" && (react_1.default.createElement(react_native_1.View, { style: { height: keyboardHeight + 22 } }))));
    };
    return react_1.default.useMemo(() => {
        var _a, _b;
        console.log("Current route id is", routeId);
        if (template.layout.type === types_1.LAYOUTS.MODAL) {
            if (routeId === 'INVITE_CLIENT' || routeId === 'PARTNER_LOGOUT' || routeId === 'PLATFORM_LOG_OUT' || routeId === 'EMPANEL_SUCCESS_MODAL' || routeId === 'CHECK_LIMIT_INFO' || routeId === 'CHECK_LIMIT_ALERT_MODAL' || (react_native_1.Platform.OS === "android" && routeId === "DIGIO_MODAL")) {
                return renderForceUpdateModal();
            }
            return routeId === "MF_FETCH_PORTFOLIO" || routeId === "PLEDGE_VERIFY" || routeId === 'CONTACT_US_CARD' || react_native_1.Platform.OS === 'web' ?
                routeId === "REGISTER_LEADS" ?
                    (react_1.default.createElement(BottomSheet_1.default, { autoAdjustHeight: false, height: (0, lodash_es_1.get)(template, 'layout.style.height', 256), width: (0, lodash_es_1.get)(template, 'layout.style.width', '100%'), alignment: (0, lodash_es_1.get)(template, 'layout.style.alignment', types_1.ModalAlignmentEnum.BOTTOM), backgroundColor: isDarkMode && phonePayRoutes.includes(routeId) ? '#0D141F' : state.routeMap[routeId].bgColor, hasDraggableIcon: false, sheetBackgroundColor: isDarkMode && phonePayRoutes.includes(routeId) ? '#0D141F' : 'white', isDismissible: !!((_a = template.layout) === null || _a === void 0 ? void 0 : _a.isDismissible), radius: 4, screenHeight: heightScreen, screenWidth: widthScreen, routeId: routeId, handleKeyboard: true }, _child)) : (react_1.default.createElement(BottomSheet_1.default, { autoAdjustHeight: false, height: (0, lodash_es_1.get)(template, 'layout.style.height', 256), width: (0, lodash_es_1.get)(template, 'layout.style.width', '100%'), alignment: (0, lodash_es_1.get)(template, 'layout.style.alignment', types_1.ModalAlignmentEnum.BOTTOM), backgroundColor: isDarkMode && phonePayRoutes.includes(routeId) ? '#0D141F' : state.routeMap[routeId].bgColor, hasDraggableIcon: false, sheetBackgroundColor: isDarkMode && phonePayRoutes.includes(routeId) ? '#0D141F' : 'white', isDismissible: !!((_b = template.layout) === null || _b === void 0 ? void 0 : _b.isDismissible), radius: 4, screenHeight: heightScreen, screenWidth: widthScreen, routeId: routeId, handleKeyboard: true }, _child))
                : renderForceUpdateModal();
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                _child,
                routeId === "KYC_ADDITIONAL_DETAILS" && (react_1.default.createElement(react_native_1.View, { style: { height: keyboardHeight } })),
                react_native_1.Platform.OS === 'android' &&
                    routeId === "REPAYMENT" && (react_1.default.createElement(react_native_1.View, { style: { height: keyboardHeight } })),
                routeId === "CO_BORROWER_PAN" && (react_1.default.createElement(react_native_1.View, { style: { height: 0 } })),
                routeId === "CO_BORROWER_ADDITIONAL_DETAILS" && (react_1.default.createElement(react_native_1.View, { style: { height: 0 } }))));
        }
    }, [
        _child,
        keyboardHeight,
        template.layout.type,
        template.layout.id,
        template.layout.isDismissible,
    ]);
};
exports.default = (0, react_1.memo)(PageRender, (0, utility_1.arePropsEqual)(['template', 'actions']));
// export const heightMapPercentage: string = {
// 	["PAN_CONFIRM_NAME"]: "20%",
// 	["ALERT_PAGE"]: "30%",
// 	["WITHDRAWAL_SUCCESS"]: 570,
// 	["WITHDRAWAL_OTP"]: 265,
// 	["LOAN_AUTOPAY"]: 258,
// 	["PLEDGE_VERIFY"]: 333,
// 	["OTP_AUTH_CAS"]: 333,
// 	["MF_FETCH_PORTFOLIO"]: 550,
// 	["UPDATE_PHONE_NUMBER"]: 274,
// 	["UPDATE_EMAIL_ID"]: 274,
// 	["MODIFY_PLEDGED_AMOUNT"]: 247+16,
// 	["SELECT_SOURCE"]: 272,
// 	["UPDATE_SLIDER_AMOUNT"]: 176,
// 	["VOLT_APP"]: 550,
// };
//# sourceMappingURL=PageRender.js.map